import client from '../../../apis/client'
import { AxiosPromise } from 'axios'
import { Prescription } from '../../../types/models/Presc'
import { localStorageWrapper } from '../../../helpers/localStorage'

export type AITranscribeResult = {
  medical_institution: {
    unified_code: string
    address: string
    name: string
  }
  format: {
    sex: string
    insurance_type: string
    birthday: string
    department_area: string
    medicine_layout: string
    dosage: string
    dispensing_quantity: string
  }
  department: {
    name: string
  }
  patient: {
    name_kanji: string
    name_kana: string
  }
  doctor: {
    name_kanji: string
    name_kana: string
  }
}

const checkAnnotatorAuth = (): boolean => {
  const isAnnotator = localStorageWrapper.getItem('is_annotator')
  if (!isAnnotator) {
    return false
  }
  return true
}

export const getPrescriptionByRequestId = (
  requestId: string
): AxiosPromise<Prescription> => {
  if (!checkAnnotatorAuth()) {
    return Promise.reject(new Error('Annotator authentication required'))
  }
  return client.get(`api/annotator/prescriptions/${requestId}/`)
}

// --- 結果確認タブ用 ---

export type ResultReviewData = {
  basic_result: {
    main_fields: { key: string; display_name: string; value: string }[]
    other_fields: { key: string; value: string }[]
  }
  med_result: {
    rp_number: number
    usage: string
    dispensing_quantity: string
    comment: string
    medications: { name: string; dosage: string; unit: string }[]
  }[]
  ocr_errors: { id: string; label: string; created_at: string }[]
}

export const getResultReview = (
  ocrRequestEventId: string
): AxiosPromise<ResultReviewData> => {
  if (!checkAnnotatorAuth()) {
    return Promise.reject(new Error('Annotator authentication required'))
  }
  return client.get(
    `api/annotator/prescriptions/${ocrRequestEventId}/result-review/`
  )
}

export const aiTranscribe = (
  ocrRequestEventId: string
): AxiosPromise<AITranscribeResult> => {
  if (!checkAnnotatorAuth()) {
    return Promise.reject(new Error('Annotator authentication required'))
  }
  return client.post(
    `api/annotator/prescriptions/${ocrRequestEventId}/ai-transcribe/`
  )
}
